export default __webpack_public_path__ + "static/media/resume.a01eadbf.pdf";